import { Helmet } from "react-helmet-async"
import React, { useEffect, useContext } from "react"
import authContext from "../../context/auth/authContext"
import { RecordPageView } from "App"
import { Container } from "reactstrap"

import GeneralComponent from "components/ProfileRefinament/GeneralComponent"

const GeneralProfile = props => {
  RecordPageView()
  const AuthContext = useContext(authContext)
  const { user, getUser, getOrganizationNew, organizationFields } = AuthContext
  useEffect(() => {
    if (!user) {
      getUser()
    }
    if (user) {
      getOrganizationNew(user["custom:organizationId"])
    }
  }, [user])

  return (
    <React.Fragment>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | General</title>
        </Helmet>
        <Container fluid>
          {user && organizationFields ? <GeneralComponent /> : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default GeneralProfile
